import type { CollectionModelState } from '../collection.state';
import { CollectionModelImageVisibilityState } from './imageVisibility.state';

export type ModelStateImageVisibilityTag = 'hidden';
export interface ModelStateImageVisibility {
	id: string;
	tag: ModelStateImageVisibilityTag;
}

export class CollectionModelImageVisibilityMutator<
	T extends CollectionModelImageVisibility = CollectionModelImageVisibility,
> {
	imageVisibility: T;

	constructor(imageVisibility: T) {
		this.imageVisibility = imageVisibility;
	}

	setValue(state: T['state']) {
		this.imageVisibility.collectionState.setFieldValue(this.imageVisibility.instanceId, state);
	}

	/** Gives a shallow clone of the image visibility state */
	getValue(): T['state'] {
		return Object.assign({}, this.imageVisibility.state);
	}

	/**
	 * Remove the state of this image visibility
	 * *Warning:* You will need to unlink & clear the image visibility before destroying the state.
	 * @see CollectionModelImageVisibilityStateMutator.remove
	 */
	destroyState() {
		this.imageVisibility.collectionState.setFieldValue(this.imageVisibility.instanceId, null);
	}

	/**
	 * Remove the image visibility,
	 * This will unlink and destroy the image visibility and all associated values.
	 *
	 * @see CollectionModelImageVisibilityStateMutator.remove
	 */
	remove() {
		this.imageVisibility.imageVisibilityState.Mutator.clear();
	}
}

export abstract class CollectionModelImageVisibility<T extends ModelStateImageVisibility = ModelStateImageVisibility> {
	abstract tag: ModelStateImageVisibilityTag;
	/** Computed id of the image visibility */
	instanceId: string;
	id: string;
	captureId: string;
	imageVisibilityState: CollectionModelImageVisibilityState;

	Mutator: CollectionModelImageVisibilityMutator;

	constructor(state: CollectionModelImageVisibilityState, imageVisibilityId: string, captureId: string) {
		this.instanceId = CollectionModelImageVisibilityState.imageVisibilityId(captureId);
		this.id = imageVisibilityId;
		this.captureId = captureId;
		this.imageVisibilityState = state;
	}

	get state(): T | null {
		return this.collectionState.getFieldValue(this.instanceId) as T;
	}

	get collectionState(): CollectionModelState {
		return this.imageVisibilityState.collection.state;
	}

	get isDeletable() {
		return true;
	}
}
